
<Card
  v-if="title || content || linkURL"
  :elevation="elevation"
  class="flex flex-row items-start justify-center w-full"
  :href="linkURL"
  :clickable="clickable"
  :target="externalLink && '_blank'"
  :aria-label="linkDescription"
  @click="$emit('click')"
>
  <div v-if="hasLeftSide" :class="leftSideClasses">
    <slot name="leftSide" />
  </div>
  <div class="flex-1 my-auto">
    <div class="flex flex-col gap-8">
      <h3 v-if="title" :class="`text-${titleColor}`" class="text-strong-body">{{ title }}</h3>
      <p v-if="content" :class="`text-${contentColor}`" class="text-small">{{ content }}</p>
      <slot name="content" />
    </div>
    <Button v-if="linkValue" :value="linkValue" variant="text" class="mt-8 px-0 text-left" />
  </div>
  <div class="my-auto">
    <slot name="rightSide" />
  </div>
</Card>
